const Header = ({ isOpen, toggleMenu, setCurrentModal }) => {
  const showAboutModal = () => {
    setCurrentModal("");
    setTimeout(() => {
      setCurrentModal("aboutModal");
    }, 50);
  }

  const showFaqModal = () => {
    setCurrentModal("");
    setTimeout(() => {
      setCurrentModal("faqModal");
    }, 50);
  }

  return (
    <header>
      <div className="header-content">
        <div className="logo-container">
          <img src={require('../assets/logo.png')} alt="TripHalal by SiapHalal" className="logo" />
        </div>

        <div className={`side-menu ${isOpen ? "open" : ""}`}>
          <button className="close-btn" onClick={toggleMenu}>
            ✖
          </button>
          <nav className="nav">
            {/* <a href="#">Home</a> */}
            <a className="nav-button" onClick={showAboutModal}>About</a>
            <a className="nav-button" onClick={showFaqModal}>FAQ</a>
          </nav>
        </div>

        <button className="nav-toggle" onClick={toggleMenu}>☰</button>
      </div>
    </header>
  )
}

export default Header